<template>
  <v-row no-gutters>
    <v-col>
      <card-title-row class="pl-0 pt-5" translation-path="sidebar.featuresIdentification"> </card-title-row>
      <sidebar-row class="pt-8 pr-5">
        <v-list v-if="hasAnyFeatures" class="py-0">
          <template v-for="(feature, idx) in identifiedFeatures">
            <v-list-item
              @click="showCard(feature.id, feature.layerId, feature)"
              @mouseleave="onHover(feature, false)"
              @mouseenter="onHover(feature, true)"
              :key="idx"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title>
                  <v-subheader class="pl-0 font--text text-body-2" style="height: auto;">
                    {{ feature.name }}: {{ feature.number || feature.descAttributeValue }}
                  </v-subheader>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action @click.stop="zoomToFeature(feature.id, feature.layerId)">
                <v-icon color="rgba(0,0,0,.7)" size="19px">mdi-magnify</v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
        <template v-else>
          <v-subheader style="height: auto;" class="text-body-2">
            {{ $i18n.t('sidebar.noIdentifiedObjects') }}
          </v-subheader>
        </template>
      </sidebar-row>
    </v-col>
  </v-row>
</template>

<script>
import identificationSidebarCard from '@/mixins/identificationSidebarCard';

import SidebarRow from '@/components/SidebarRow';
import CardTitleRow from '@/components/CardTitleRow';

export default {
  name: 'Identification',
  mixins: [identificationSidebarCard],
  components: {
    SidebarRow,
    CardTitleRow,
  },
};
</script>

<style lang="scss" scoped>
.v-list {
  @include border();
  .v-list-item {
    &:not(:last-child) {
      @include border(bottom);
    }
  }
}
</style>
